var _circle, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRound4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 89,
    viewBox: "0 0 89 89",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 44.5,
    cy: 44.5,
    r: 32.5,
    fill: "#A098AE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36 10C36 10 40.9799 9 44.5 9C48.0201 9 53 10 53 10",
    stroke: "#434242",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53 79C53 79 48.0201 80 44.5 80C40.9799 80 36 79 36 79",
    stroke: "#434242",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 53C10 53 9 48.0201 9 44.5C9 40.9799 10 36 10 36",
    stroke: "#434242",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M79 36C79 36 80 40.9799 80 44.5C80 48.0201 79 53 79 53",
    stroke: "#434242",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRound4);
export default __webpack_public_path__ + "static/media/round4.11708bacd61b51334815cfaeb1c3a962.svg";
export { ForwardRef as ReactComponent };